/* @flow */
import Unreads from 'collections/Unreads';
import { ActionTypes } from 'constants/UnreadConstants';
import { dispatcher } from 'lib/Dispatcher';

const UnreadActions = {
  loadUnreads(): Promise<void> {
    return Unreads.fetch().then(unreads => {
      dispatcher.dispatch({
        type: ActionTypes.LIST_UNREADS,
        unreads,
      });
    });
  },
};

export default UnreadActions;



// WEBPACK FOOTER //
// ./src/actions/UnreadActions.js